module.exports = __webpack_public_path__ + "img/canada.5d08ccab.svg";